import React, { useState } from 'react';
import './preview-event.sass';
import { Button, ButtonSize, ButtonType } from '../../../../components/interface/button/button';
import DateIcon from '../../assets/preview/Date_icon.png';
import TimeIcon from '../../assets/preview/Time_icon.png';
import MarkerIcon from '../../assets/preview/Marker_icon.png';
import PictureIcon from '../../assets/preview/Picture_icon.png';
import NewWindowIcon from '../../assets/preview/New_window_icon.png';
import { useScrollElement } from '../../../../components/hooks/use-scroll-element';
import PlaceholderConcerts from '../../assets/preview/Category=Koncert.png';
import PlaceholderMovies from '../../assets/preview/Category=Kino.png';
import PlaceholderShows from '../../assets/preview/Category=Spektakl.png';
import PlaceholderSports from '../../assets/preview/Category=Sport.png';
import PlaceholderStandups from '../../assets/preview/Category=Standup.png';
import PlaceholderArtShows from '../../assets/preview/Category=Wystawa.png';
import PlaceholderOthers from '../../assets/preview/Category=Inne.png';


const DaysOfTheWeek = {
    0: 'Niedziela',
    1: 'Poniedziałek',
    2: 'Wtorek',
    3: 'Środa',
    4: 'Czwartek',
    5: 'Piątek',
    6: 'Sobota'
};

const placeHolderImages = {
    'Spektakle': PlaceholderShows,
    'Koncerty': PlaceholderConcerts,
    'Wystawy': PlaceholderArtShows,
    'Filmy': PlaceholderMovies,
    'Sport': PlaceholderSports,
    'Stand-upy': PlaceholderStandups,
    'Inne': PlaceholderOthers
};


export const PreviewEvent = ({event, scrollRef}) => {

    const [moreText, setMoreText] = useState(false);

    const {onScroll} = useScrollElement(scrollRef);

    const parseDate = (date) => {
        let dateToParse = new Date(date);
        let weekDay = DaysOfTheWeek[dateToParse.getDay()];
        return `${dateToParse.toLocaleDateString()}, ${weekDay}`;
    };

    function padTo2Digits(num) {
        return String(num).padStart(2, '0');
    }

    const parseTime = (date) => {
        let dateToParse = new Date(date);
        return `${padTo2Digits(dateToParse.getUTCHours())}:${padTo2Digits(dateToParse.getUTCMinutes())}`;
    };

    const hideText = () => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        setMoreText(false);
    };

    return (
        <div className='vv-preview-event-container'>
            <div className='vv-preview-event'>
                <h2>{event.title}</h2>
                <div className='vv-preview-event__content'>
                    <div className='vv-preview-event__left'>
                        {
                            event.cover_photo_url ?
                                <img className='vv-preview-event__photo' src={event.cover_photo_url} alt='event photo'/>
                                :
                                <img className='vv-preview-event__photo' src={placeHolderImages[event.type.label]} alt='placeholder'/>
                        }
                        {
                            event.cover_photo_url_source ?
                                <div className='vv-preview-event__photo-description'>
                                    <img src={PictureIcon} alt='description icon'/>
                                    <a href={event.cover_photo_url_source}><span>{'Zdjęcie: autor & licencja'}</span></a>
                                </div>
                                :
                                null
                        }
                        {
                            event.description ?
                            <>
                                <div className={moreText ? 'description-text-height-full' : 'description-text-height'}>
                                    <p>{event.description}</p>
                                </div>
                                <div className={'description-more-text'}>
                                    {
                                        moreText ?
                                            <span onClick={() => hideText()}>Schowaj</span>
                                            :
                                            <span onClick={() => setMoreText(true)}>Więcej</span>
                                    }
                                </div>

                            </>
                                :
                            <a href={event?.ticket_url} className='vv-preview-event__check-description'>
                                <p>Sprawdź opis na stronie wydarzenia</p>
                                <img className='vv-preview-event__new-window-icon' src={NewWindowIcon} alt='icon'/>
                            </a>
                        }
                    </div>
                    <div className='vv-preview-event__right'>
                        <div className='vv-preview-event__tags'>
                            {
                                event.categories.map((category, i) =>
                                    <p key={i}>{`#${category.label}`}</p>
                                )
                            }
                        </div>
                        <div className='vv-preview-event__line'/>
                        <div className='vv-preview-event__date-time-container'>
                            <div className='vv-preview-event__date-container'>
                                <img src={DateIcon} className='vv-preview-event__date' alt='date icon'/>
                                <p>{parseDate(event.start_date)}</p>
                            </div>
                            <div className='vv-preview-event__time-container'>
                                <img src={TimeIcon} className='vv-preview-event__time' alt='time icon'/>
                                <p>{parseTime(event.start_date)}</p>
                            </div>
                        </div>
                        <div className='vv-preview-event__line'/>
                        <div className='vv-preview-event__location-container'>
                            <div>
                                <img src={MarkerIcon} alt='marker icon'/>
                            </div>
                            <div className='vv-preview-event__location-description'>
                                <p>{event.place.name}</p>
                                <p>{event.address_location}</p>
                            </div>
                        </div>
                        <div className='vv-preview-event__line'/>
                        <div className='vv-preview-event__button-container'>
                            <Button size={ButtonSize.BIG} buttonType={ButtonType.YELLOW} text={'POBIERZ APLIKACJĘ VICEVERSA'} onClick={() => onScroll()}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};